import { ApolloClient, InMemoryCache, createHttpLink, split } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { Kind, OperationTypeNode } from 'graphql/language';
import io from 'socket.io-client';
import Cookies from 'universal-cookie';

import { scanUser } from '../pages/users/partials/log';
import { expiredUser } from '../pages/users/partials/logout';

const cookies = new Cookies();

const getToken = () => {
  const Retoken: string = cookies.get('token');
  return Retoken;
};

const link = createHttpLink({ uri: import.meta.env.VITE_GRAPHQL_URL });

let websocketRetryAttempt = 0;

const wsClient = createClient({
  url: import.meta.env.VITE_SUBSCRIPTION_URL,
  lazy: true,
  retryAttempts: Infinity,
  connectionParams: () => {
    const token = getToken();
    intrigueToken();

    return {
      authorization: token ? `Bearer ${token}` : '',
    };
  },
  shouldRetry: () => {
    websocketRetryAttempt += 1;
    console.log(`websocket retry attempt ${websocketRetryAttempt}`);
    return true;
  },
  on: {
    connected: () => {
      websocketRetryAttempt = 0;
      console.log('websocket connected!!');
    },
    closed: (event) => {
      const closeEvent = event as CloseEvent;
      console.log('websocket closed!!', {
        code: closeEvent.code,
        reason: closeEvent.reason,
        wasClean: closeEvent.wasClean,
        willRetry: true,
      });
    },
    error: (error) => {
      console.log('websocket error!!', error);
    },
  },
});
const wsLink = new GraphQLWsLink(wsClient);

const intrigueToken = () => {
  const token = getToken();
  if (!token) {
    const callbackToken = () => {
      void expiredUser();
    };
    scanUser()
      .then((result) => {
        if (!result) {
          callbackToken();
        }
      })
      .catch((error) => {
        console.error('Error Checking Login', error);
        callbackToken();
      });
  }
};

const forstokHttpLink = link;

const splitLink = split(
  ({ query }) => {
    const definition = query.definitions.find((item) => item.kind === Kind.OPERATION_DEFINITION);
    return definition?.operation === OperationTypeNode.SUBSCRIPTION;
  },
  wsLink,
  forstokHttpLink,
);

const forstokAuthLink = setContext((_, { headers }) => {
  const token = getToken();
  intrigueToken();
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        picklists: {
          merge(existing: Record<string, unknown> | undefined, incoming: Record<string, unknown>) {
            return { ...existing, ...incoming };
          },
        },
        stockInbounds: {
          merge(existing: Record<string, unknown> | undefined, incoming: Record<string, unknown>) {
            return { ...existing, ...incoming };
          },
        },
      },
    },
    Warehouses: {
      keyFields: ['id'],
    },
    Accounts: {
      keyFields: ['id', ['name']],
    },
    ProductWarehouse: {
      keyFields: false,
      merge: true,
    },
    WarehouseInventoryPromotion: {
      keyFields: false,
    },
    WarehouseInventoryReservedOrder: {
      keyFields: false,
    },
    Bin: {
      keyFields: false,
    },
  },
  addTypename: true,
});

export const client = new ApolloClient({
  link: forstokAuthLink.concat(splitLink),
  cache,
  queryDeduplication: false,
});

export const socket = io('wss://socket.forstok.com');
